// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3sg1T","footer":"ChangeClinic_footer__2wWG1"};